@if(isLoading){
<div class="loading">
  <div class="loading_txt">
  <div class="load_txt">Loading</div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
  </div>
</div>
}
@if(landingprebook){
    @if(data | async; as data){
        <!--link section-->
        <div class="materials_Link_Section">
            <a href="#accordion_Section" (click)="scrollToSection('accordion_Section', $event)" class="materials_Link"
                [innerHTML]="data?.paragraphcontent"></a>
        </div>
        <!--image and popup section-->
        <div class="image_Popup_Container">
            <div class="image_container" [ngStyle]="{'background-image': 'url(' + getImage(data?.UptakeImg1) + ')'}" (click)="closePopup()">
                <!-- <img [src]="getImage(data?.UptakeImg1)" alt="Prebook Banner" class="hospital_Img"> -->
                <div class="descripton_Txt" [innerHTML]="'materialprebook.discoverButton' | cxTranslate"></div>
                <div class="icon_Btn_Container waiting_Room" (click)="openPopup(1, $event,'waiting_room')">
                    <button class="popup_Btn"
                        [class.faded]="activeIndex !== -1 && activeIndex !== getIndex(1)">{{"materialprebook.wiatingRoomBtn" | cxTranslate}} </button>
                    <img src="assets/images/Location Pin.svg" class="location_Img">
                </div>
                <div class="icon_Btn_Container consultation_Room" (click)="openPopup(2, $event,'consultation_room')">
                    <button class="popup_Btn"
                        [class.faded]="activeIndex !== -1 && activeIndex !== getIndex(2)">{{"materialprebook.consultationBtn" | cxTranslate}}</button>
                    <img src="assets/images/Location Pin.svg" class="location_Img">
                </div>
                <div class="icon_Btn_Container reception_Area" (click)="openPopup(3, $event,'reception_area')">
                    <button class="popup_Btn"
                        [class.faded]="activeIndex !== -1 && activeIndex !== getIndex(3)">{{"materialprebook.receptionBtn" | cxTranslate}}</button>
                    <img src="assets/images/Location Pin.svg" class="location_Img">
                </div>
                <div class="icon_Btn_Container outside_Clinic" (click)="openPopup(4, $event,'outside_clinic')">
                    <button class="popup_Btn"
                        [class.faded]="activeIndex !== -1 && activeIndex !== getIndex(4)">{{"materialprebook.outsideBtn" | cxTranslate}}</button>
                    <img src="assets/images/Location Pin.svg" class="location_Img">
                </div>
            </div>
            @for( item of cardsList; track item;let i= $index){
            <div class="popup list_Popup" 
                [class.visible]="activeIndex === i" (click)="$event.stopPropagation()">
                <div class="headline_Container">
                    <div class="headLine" [innerHTML]="item.headline"></div>
                    <button class="close popup_Close" (click)="closePopup()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path
                                d="M6.575 7.975L1.675 12.875C1.49167 13.0583 1.25833 13.15 0.975 13.15C0.691667 13.15 0.458333 13.0583 0.275 12.875C0.0916663 12.6917 0 12.4583 0 12.175C0 11.8917 0.0916663 11.6583 0.275 11.475L5.175 6.575L0.275 1.675C0.0916663 1.49167 0 1.25833 0 0.975C0 0.691667 0.0916663 0.458333 0.275 0.275C0.458333 0.0916663 0.691667 0 0.975 0C1.25833 0 1.49167 0.0916663 1.675 0.275L6.575 5.175L11.475 0.275C11.6583 0.0916663 11.8917 0 12.175 0C12.4583 0 12.6917 0.0916663 12.875 0.275C13.0583 0.458333 13.15 0.691667 13.15 0.975C13.15 1.25833 13.0583 1.49167 12.875 1.675L7.975 6.575L12.875 11.475C13.0583 11.6583 13.15 11.8917 13.15 12.175C13.15 12.4583 13.0583 12.6917 12.875 12.875C12.6917 13.0583 12.4583 13.15 12.175 13.15C11.8917 13.15 11.6583 13.0583 11.475 12.875L6.575 7.975Z"
                                fill="#2A3237" />
                        </svg>
                    </button>
                </div>
                <div class="pictures_Section">
                    <div class="pictures_Container">
                        <div class="txt_container" [innerHTML]="item?.h2content"></div>
                        <img class="list_Img" [src]="getImage(item?.media)">
                    </div>
                    @if(item?.picture2){
                    <div class="pictures_Container_Two" >
                        <div class="txt_container" [innerHTML]="item?.content"></div>
                        @if(item?.picture2){
                        <img class="list_Img"  [src]="getImage(item?.picture2)">
                        }
                    </div>
                  }
                </div>
            </div>
          }
        </div>
        <!--Digital consent section-->
        @if(!digitConsent && !isAsmUser){
        <div class="digital_Consent_Container" >
            <div class="txt_Set">
                <div class="digital_Headline" [innerHTML]="data.text1"></div>
                <div class="digital_Description" [innerHTML]="data.text2"></div>
                <div class="digtal_Txt" [innerHTML]="data.text3"></div>
                <div class="digital_Consent">
                    <label>
                        <input type="checkbox" [(ngModel)]="digitalUserConsent"
                            (ngModelChange)="onDigitalConsentChange($event)" class="consent_Checkbox"
                            [disabled]="disableCheckbox" />
                        <span class="checkbox-button__control"></span>
                    </label>
                    @if(!digitalUserConsent){
                    <div  class="digital_Terms_Conditions" [innerHTML]="data.text4"></div>
                    }
                    @if(digitalUserConsent){
                    <div class="thank_Txt" [innerHTML]="data.headline"></div>
                    }
                </div>
            </div>
            <div class="img_Section">
                <img [src]="getImage(data?.UptakeImg2)" alt="Digital Consent" class="digital_Img" />
            </div>
        </div>
      }
        <!--accordion section -->
        <div class="accordion_Section" id="accordion_Section">
          <div class="headline_Txt" [innerHTML]="data.largeparagraphcontent"></div>
          <div class="accordion_Container mt-4">
            <div class="accordion-wrapper">
              <div class="accordion mt-4" id="bundleAccordion">
                <!-- Accordion 1 -->
                <div class="accordion-item border-0 shadow-none equal-box">
                  @if(!isBundleAdded('BUNDLE_CODE_1')){
                  <button class="add_Bundle" (click)="addBundle('BUNDLE_CODE_1')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M18 12.998H13V17.998C13 18.2633 12.8946 18.5176 12.7071 18.7052C12.5196 18.8927 12.2652 18.998 12 18.998C11.7348 18.998 11.4804 18.8927 11.2929 18.7052C11.1054 18.5176 11 18.2633 11 17.998V12.998H6C5.73478 12.998 5.48043 12.8927 5.29289 12.7052C5.10536 12.5176 5 12.2633 5 11.998C5 11.7328 5.10536 11.4785 5.29289 11.2909C5.48043 11.1034 5.73478 10.998 6 10.998H11V5.99805C11 5.73283 11.1054 5.47848 11.2929 5.29094C11.4804 5.1034 11.7348 4.99805 12 4.99805C12.2652 4.99805 12.5196 5.1034 12.7071 5.29094C12.8946 5.47848 13 5.73283 13 5.99805V10.998H18C18.2652 10.998 18.5196 11.1034 18.7071 11.2909C18.8946 11.4785 19 11.7328 19 11.998C19 12.2633 18.8946 12.5176 18.7071 12.7052C18.5196 12.8927 18.2652 12.998 18 12.998Z"
                        fill="#5D6F7B" />
                    </svg>
                    <span>{{"materialprebook.addSmall" | cxTranslate}}</span>
                  </button>
                }
                @if(isBundleAdded('BUNDLE_CODE_1')){
                  <button class="remove_Bundle"  (click)="removeBundle('BUNDLE_CODE_1')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="2" viewBox="0 0 14 2" fill="none">
                      <path
                        d="M13 2H1C0.734784 2 0.48043 1.89464 0.292893 1.70711C0.105357 1.51957 0 1.26522 0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1C14 1.26522 13.8946 1.51957 13.7071 1.70711C13.5196 1.89464 13.2652 2 13 2Z"
                        fill="white" />
                    </svg>
                    <span>{{"materialprebook.removeSmall" | cxTranslate}}</span>
                  </button>
                }
                  @for( bundle of materailwholedata;track bundle){
                   @if(bundle.code == 'BUNDLE_CODE_1'){
                      <img [src]="getImage(bundle?.tileImage)" class="accordion_Img">
                   }
                  }
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed no-border" data-bs-toggle="collapse"
                      data-bs-target="#collapseOne">
                      <span class="see_Details_Btn">{{"materialprebook.seeDetails" | cxTranslate}}</span>
                      <span class="arrow">
                        <img src="/assets/images/accordiondown.svg">
                      </span>
                    </button>
                  </h2>
                  <div id="collapseOne" class="accordion-collapse collapse">
                    <div class="accordion-body" [innerHTML]="data.LargeText1"></div>
                  </div>
                </div>
                <!-- Accordion 2 -->
                <div class="accordion-item border-0 shadow-none equal-box">
                  @if(!isBundleAdded('BUNDLE_CODE_2')){
                  <button class="add_Bundle" (click)="addBundle('BUNDLE_CODE_2')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M18 12.998H13V17.998C13 18.2633 12.8946 18.5176 12.7071 18.7052C12.5196 18.8927 12.2652 18.998 12 18.998C11.7348 18.998 11.4804 18.8927 11.2929 18.7052C11.1054 18.5176 11 18.2633 11 17.998V12.998H6C5.73478 12.998 5.48043 12.8927 5.29289 12.7052C5.10536 12.5176 5 12.2633 5 11.998C5 11.7328 5.10536 11.4785 5.29289 11.2909C5.48043 11.1034 5.73478 10.998 6 10.998H11V5.99805C11 5.73283 11.1054 5.47848 11.2929 5.29094C11.4804 5.1034 11.7348 4.99805 12 4.99805C12.2652 4.99805 12.5196 5.1034 12.7071 5.29094C12.8946 5.47848 13 5.73283 13 5.99805V10.998H18C18.2652 10.998 18.5196 11.1034 18.7071 11.2909C18.8946 11.4785 19 11.7328 19 11.998C19 12.2633 18.8946 12.5176 18.7071 12.7052C18.5196 12.8927 18.2652 12.998 18 12.998Z"
                        fill="#5D6F7B" />
                    </svg>
                    <span>{{"materialprebook.addMedium" | cxTranslate}}</span>
                  </button>
                }
                @if(isBundleAdded('BUNDLE_CODE_2')){
                  <button class="remove_Bundle"  (click)="removeBundle('BUNDLE_CODE_2')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="2" viewBox="0 0 14 2" fill="none">
                      <path
                        d="M13 2H1C0.734784 2 0.48043 1.89464 0.292893 1.70711C0.105357 1.51957 0 1.26522 0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1C14 1.26522 13.8946 1.51957 13.7071 1.70711C13.5196 1.89464 13.2652 2 13 2Z"
                        fill="white" />
                    </svg>
                    <span>{{"materialprebook.removeMedium" | cxTranslate}}</span>
                  </button>
                }

                  @for(bundle of materailwholedata;track bundle){
                    @if(bundle.code == 'BUNDLE_CODE_2'){
                      <img [src]="getImage(bundle?.tileImage)" class="accordion_Img">
                    }
                  }
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed no-border" data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo">
                      <span class="see_Details_Btn">{{"materialprebook.seeDetails" | cxTranslate}}</span>
                      <span class="arrow">
                        <img src="/assets/images/accordiondown.svg">
                      </span>
                    </button>
                  </h2>
                  <div id="collapseTwo" class="accordion-collapse collapse">
                    <div class="accordion-body" [innerHTML]="data.LargeText2"></div>
                  </div>
                </div>
                <!-- Accordion 3 -->
                <div class="accordion-item border-0 shadow-none equal-box">
                  @if(!isBundleAdded('BUNDLE_CODE_3')){
                  <button class="add_Bundle"  (click)="addBundle('BUNDLE_CODE_3')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M18 12.998H13V17.998C13 18.2633 12.8946 18.5176 12.7071 18.7052C12.5196 18.8927 12.2652 18.998 12 18.998C11.7348 18.998 11.4804 18.8927 11.2929 18.7052C11.1054 18.5176 11 18.2633 11 17.998V12.998H6C5.73478 12.998 5.48043 12.8927 5.29289 12.7052C5.10536 12.5176 5 12.2633 5 11.998C5 11.7328 5.10536 11.4785 5.29289 11.2909C5.48043 11.1034 5.73478 10.998 6 10.998H11V5.99805C11 5.73283 11.1054 5.47848 11.2929 5.29094C11.4804 5.1034 11.7348 4.99805 12 4.99805C12.2652 4.99805 12.5196 5.1034 12.7071 5.29094C12.8946 5.47848 13 5.73283 13 5.99805V10.998H18C18.2652 10.998 18.5196 11.1034 18.7071 11.2909C18.8946 11.4785 19 11.7328 19 11.998C19 12.2633 18.8946 12.5176 18.7071 12.7052C18.5196 12.8927 18.2652 12.998 18 12.998Z"
                        fill="#5D6F7B" />
                    </svg>
                    <span>{{"materialprebook.addLarge" | cxTranslate}}</span>
                  </button>
                }
                @if(isBundleAdded('BUNDLE_CODE_3')){
                  <button class="remove_Bundle"  (click)="removeBundle('BUNDLE_CODE_3')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="2" viewBox="0 0 14 2" fill="none">
                      <path
                        d="M13 2H1C0.734784 2 0.48043 1.89464 0.292893 1.70711C0.105357 1.51957 0 1.26522 0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1C14 1.26522 13.8946 1.51957 13.7071 1.70711C13.5196 1.89464 13.2652 2 13 2Z"
                        fill="white" />
                    </svg>
                    <span>{{"materialprebook.removeLarge" | cxTranslate}}</span>
                  </button>
                }
              
                 @for( bundle of materailwholedata;track bundle){
                    @if(bundle.code == 'BUNDLE_CODE_3'){
                      <img [src]="getImage(bundle?.tileImage)" class="accordion_Img">
                    }
                 }
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed no-border" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                      <span class="see_Details_Btn">{{"materialprebook.seeDetails" | cxTranslate}}</span>
                      <span class="arrow">
                        <img src="/assets/images/accordiondown.svg">
                      </span>
                    </button>
                  </h2>
                  <div id="collapseThree" class="accordion-collapse collapse">
                    <div class="accordion-body" [innerHTML]="data.LargeText3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
     <!-- User Consent Section -->
      @if(!marketingConsent && !isAsmUser){
     <div class="user_Consent" >
      <label>
          <input type="checkbox" [(ngModel)]="marketingConsentGiven" class="consent_Checkbox" />
          <span class="checkbox-button__control"></span>
      </label>
      <div class="terms_And_Conditions" [innerHTML]="data.content"></div>
  </div>
}
  <!--continue button-->
  <button class="continue_Button" [disabled]="isContinueDisabled" (click)="continuebtn()">
      <span [innerHTML]="data.h2content"></span>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
              d="M12.6 11.9998L8.70005 8.0998C8.51672 7.91647 8.42505 7.68314 8.42505 7.3998C8.42505 7.11647 8.51672 6.88314 8.70005 6.6998C8.88338 6.51647 9.11671 6.4248 9.40005 6.4248C9.68338 6.4248 9.91672 6.51647 10.1 6.6998L14.7 11.2998C14.8 11.3998 14.871 11.5081 14.913 11.6248C14.955 11.7415 14.9757 11.8665 14.975 11.9998C14.9744 12.1331 14.9537 12.2581 14.913 12.3748C14.8724 12.4915 14.8014 12.5998 14.7 12.6998L10.1 17.2998C9.91672 17.4831 9.68338 17.5748 9.40005 17.5748C9.11671 17.5748 8.88338 17.4831 8.70005 17.2998C8.51672 17.1165 8.42505 16.8831 8.42505 16.5998C8.42505 16.3165 8.51672 16.0831 8.70005 15.8998L12.6 11.9998Z" />
      </svg>
  </button>
 
  
}
      }
@if(locationsection){
<section class="locationsection col-xs-12" >
  <div class="materials_backbtn col-xs-12 no-padding"  (click)="backtolanding()">
    <div class="global_blackarrow materialarrow"></div>
    {{"materialprebook.backBtn" | cxTranslate}}
  </div>
  <div class="headPre col-xs-12">{{"materialprebook.finaliseBtn" | cxTranslate}}</div>
    <div class="materials_locationsubsection col-xs-12 no-padding">
        <div>
          <span class="col-xs-12 materials_locationheader no-padding"> {{"materialprebook.locatin" | cxTranslate}} </span>
          <p class="col-xs-11 materials_locationsubheader no-padding">Please select the locations you would like to ship these materials to or add a new location below.</p>
        </div>
        <div class="col-xs-12 materials_locationlist no-padding">
          <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="checkbox">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" class="col-xs-1">
                <div class="materials_selection">
                  <label class="checkbox-button"><input type="checkbox" class="material_checkbox" name="checkbox"
                      disabled="true" [(ngModel)]="element.checked" /><span class="checkbox-button__control"></span>
                  </label>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="shippingOrganizationName">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" [ngClass]="element.checked ? 'disbleRow' : ''" class="col-xs-3">
                {{ element.shippingOrganizationName }}
              </td>
            </ng-container>
            <ng-container matColumnDef="shippingAddressLine1">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" [ngClass]="element.checked ? 'disbleRow' : ''" class="col-xs-2">
                {{ element.shippingAddressLine1 }}
              </td>
            </ng-container>
            <ng-container matColumnDef="col4">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" [ngClass]="element.checked ? 'disbleRow' : ''" class="col-xs-4">
                {{ element.town }}, {{element.postalCode}}
              </td>
            </ng-container>
            <ng-container matColumnDef="orderExists">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element"  class="col-xs-3">
                @if(element.orderExists=='true'){
               <span  class="materialloc">{{"materialprebook.preExistTxt" | cxTranslate}} <a class="materiallink" routerLink="/materialOrder/my-orders">My Materials</a> to view</span>
                }
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="rowSelected(row)" [ngClass]="
           { 'materials_unselected': !row.selected,
            'materials_selected':row.selected,
                  'non_selectable': row.orderExists === 'true'
          }" class="col-xs-12 materials_locations"></tr>
          </table>
          @if(!displayAddressForm){
          <a class="col-xs-12 materials_addlocation no-padding" (click)="displayAddress()" >{{"MaterialUk.differnt" | cxTranslate}} <span class="plussign-round"></span>
          </a>
        }
        </div>
      </div>
      @if(displayAddressForm){
      <div class="col-xs-12 materials_locationnew no-padding" >
        <div class="col-xs-12 materials_locationsection">
          <div class="col-xs-6 materials_locheader">{{"MaterialUk.addnew" | cxTranslate}}</div>
          <div class="col-xs-6 materials_locremove" (click)="displayAddress()">
            {{"MaterialUk.textremove" | cxTranslate}}
          </div>
          <div class="col-xs-6 materials_locheader padding-T20">{{"MaterialUk.devlivery" | cxTranslate}}</div>
          <form class="materials_addform col-xs-12" id="materials_addform" autocomplete="off" novalidate="novalidate"
            [formGroup]="addressForm" (ngSubmit)="onSubmit()">
            <div>
              <div class="row">
                <div class="col-xs-12 col-md-6 form-group pl-0">
                  <label for="mat_orgname">{{"MaterialUk.orgname" | cxTranslate}}</label><input type="text" id="mat_orgname" name="mat_orgname"
                    class="form-control" formControlName="organizationName" />
                    @if(
                    (getFormControl('organizationName')?.touched &&
                      getFormControl('organizationName')?.hasError('pattern')) ||
                    (getFormControl('organizationName')?.untouched && isSubmitted)
                    ){
                  <img class="lineIcon" src="/assets/images/exclamation-mark.png" alt="error">
                  <label id="mat_add1-error" class="error help-block" for="mat_add1">Please enter only letters</label>
                    }
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-12 form-group pl-0">
                  <label for="address">{{"MaterialUk.addresslook" | cxTranslate}}</label><input type="text" id="address" name="mat_addlookup"
                    class="form-control" modified-id="" formControlName="address" />
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-6 form-group pl-0">
                  <label for="line1">{{"MaterialUk.address1" | cxTranslate}}<sup>*</sup></label><input type="text" id="line1" name="mat_add1"
                    class="form-control address_FromControl" formControlName="line1"/>
                  @if(
                      (getFormControl('line1')?.touched &&
                        getFormControl('line1')?.hasError('required')) ||
                      (getFormControl('line1')?.untouched && isSubmitted)
                  ){
                    <img class="lineIcon" src="/assets/images/exclamation-mark.png" alt="error">
                    <label id="mat_add1-error" class="error help-block" for="mat_add1">{{"MaterialUk.addresserror" | cxTranslate}}</label>
                  }
                </div>
                <div class="col-xs-12 col-md-6 form-group">
                  <label for="city">{{"MaterialUk.city" | cxTranslate}}<sup>*</sup></label><input type="text" id="city" name="mat_city"
                    class="form-control city_FromControl" formControlName="city"/>
                 @if(
                      (getFormControl('city')?.touched &&
                        getFormControl('city')?.hasError('required')) ||
                      (getFormControl('city')?.untouched && isSubmitted)
                 ){
                    <img class="cityIcon" src="/assets/images/exclamation-mark.png" alt="error">
                    <label id="mat_add1-error" class="error help-block" for="mat_add1">{{"MaterialUk.cityerror" | cxTranslate}}</label>
                 }
                 @if(
                      getFormControl('city')?.touched &&
                      getFormControl('city')?.hasError('pattern')
                 ){
                    <img class="cityIcon" src="/assets/images/exclamation-mark.png" alt="error">
                    <label id="mat_add1-error" class="error help-block" for="mat_add1">{{"MaterialUk.lettererror" | cxTranslate}}</label>
                 }
                </div>
              </div>
              <div class="row">
                <div class="col-xs-7 col-md-3 form-group pl-0">
                  <label for="code">{{"MaterialUk.postcode" | cxTranslate}}<sup>*</sup></label><input type="text" id="code" name="mat_post"
                    class="form-control postcode_FromControl" formControlName="code"/>
                 @if(
                      (getFormControl('code')?.touched &&
                        getFormControl('code')?.invalid) ||
                      (getFormControl('code')?.untouched && isSubmitted)
                 ){
                    <img class="codeIcon" src="/assets/images/exclamation-mark.png" alt="error">
                    <label id="mat_add1-error" class="error help-block" for="mat_add1">{{"MaterialUk.postcodeerror" | cxTranslate}}</label>
                 }
                </div>
                <div class="col-xs-5 col-md-3 form-group">
                  <label for="country">{{"MaterialUk.Country" | cxTranslate}}<sup>*</sup></label><input type="text" id="country" name="mat_country"
                    class="form-control country_FromControl" formControlName="country"/>
                 @if(
                      (getFormControl('country')?.touched &&
                        getFormControl('country')?.hasError('required')) ||
                      (getFormControl('country')?.untouched && isSubmitted)
                 ){
                    <img class="countryIcon" src="/assets/images/exclamation-mark.png" alt="error">
                    <label id="mat_add1-error" class="error help-block" for="mat_add1">{{"MaterialUk.countryerror" | cxTranslate}}</label>
                 }
                  @if(
                      getFormControl('country')?.touched &&
                      getFormControl('country')?.hasError('pattern')
                  ){
                    <img class="countryIcon" src="/assets/images/exclamation-mark.png" alt="error">
                    <label id="mat_add1-error" class="error help-block" for="mat_add1">{{"MaterialUk.lettererror" | cxTranslate}}</label>
                  }
                </div>
              </div>
            </div>
            <button type="submit" class="mat_addloc">Save</button>
          </form>
        </div>
      </div>
    }
      <button class="place_preorder col-xs-12" (click)="placematerial()" [disabled]="locationplace">Place pre-order</button>
</section>
}
@if(thankyou){
<section class="thankyouMaterial col-xs-12" >
  <div class="thank_section col-xs-12 no-padding">
    <div class="thankhead">
      {{"materialprebook.thnxTxt" | cxTranslate}}

    </div>
    <a class="viewmaterial" routerLink="/materialOrder/my-orders">
      {{"materialprebook.viewMat" | cxTranslate}}

    </a>
  </div>
 
  <div class="thanksubhead no-padding col-xs-12">
    {{"materialprebook.updatedThankSubTxt" | cxTranslate}}
  </div>

</section>
}
